import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
} from "reactstrap";
import Papa from "papaparse";
import { importAmanoReport } from "helpers/fakebackend_helper";

const ImportAmanoReportModal = ({ isOpen, toggle }) => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [file, setFile] = useState(null);
    const [parsedData, setParsedData] = useState([]);
    const [isCorrectFormat, setIsCorrectFormat] = useState(null);
    const [loading, setLoading] = useState(false);

    const requiredColumns = [
        "Processing Date",
        "Amount",
        "Type",
        "Split Funding Amount",
        "Chargeback Count",
        "Chargeback Amount",
        "Fee Amount",
        "Reserve Amount",
        "Released Amount",
        "Batch ID",
        "Batch Amount",
        "Batch Date",
        "Split Funding Amount_1"
    ];

    const handleFileChange = (e) => {
        const uploadedFile = e.target.files[0];
        setFile(uploadedFile);

        Papa.parse(uploadedFile, {
            header: true,
            skipEmptyLines: true,
            beforeFirstChunk: (chunk) => {
                const rows = chunk.split(/\r\n|\r|\n/);
                return rows.slice(3).join("\n");
            },
            complete: function (results) {
                const rows = results.data;
                console.log("rows:", rows);
                setParsedData(rows);

                const parsedColumns = results.meta.fields || [];

                // Find missing and extra columns
                const missingColumns = requiredColumns.filter(
                    (col) => !parsedColumns.includes(col)
                );
                const extraColumns = parsedColumns.filter(
                    (col) => !requiredColumns.includes(col)
                );

                // Check if structure matches
                const hasAllRequired =
                    missingColumns.length === 0 && extraColumns.length === 0;

                if (!hasAllRequired) {
                    console.warn("⚠️ CSV column mismatch detected!");
                    if (missingColumns.length > 0)
                        console.warn("Missing columns:", missingColumns);
                    if (extraColumns.length > 0)
                        console.warn("Extra columns:", extraColumns);
                }

                setIsCorrectFormat(hasAllRequired ? 1 : 0);
            },
        });
    };

    const importData = async () => {
        try {
            setLoading(true);
            await importAmanoReport(user.token, parsedData);
        } catch (error) {
            console.error("Import failed:", error);
        } finally {
            toggle()
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Import Amano Report (for 3330 W Cahuenga)</ModalHeader>
            <ModalBody>
                <Input type="file" onChange={handleFileChange} accept=".csv" />

                {file && (
                    <div className="mt-3">
                        <h6>File Information</h6>
                        <p className="mb-1">
                            <strong>Name:</strong> {file.name}
                        </p>
                        <p className="mb-1">
                            <strong>Size:</strong>{" "}
                            {(file.size / 1024 / 1024).toFixed(2)} MB
                        </p>
                        <p className="mb-1">
                            <strong>Type:</strong> {file.type || "N/A"}
                        </p>
                        <p className="mb-1">
                            <strong>Correct Format?:</strong>
                            {isCorrectFormat === 1 ? (
                                <span
                                    className="badge bg-success"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 10,
                                        padding: 5,
                                        color: "#FFFFFF",
                                        marginLeft: 10
                                    }}
                                >
                                    YES
                                </span>
                            ) : isCorrectFormat === 0 ? (
                                <span
                                    className="badge bg-danger"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 10,
                                        padding: 5,
                                        color: "#FFFFFF",
                                        marginLeft: 10
                                    }}
                                >
                                    NO, CONTACT DEVELOPER
                                </span>
                            ) : null}
                        </p>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Close
                </Button>
                {isCorrectFormat === 1 && (
                    <Button
                        color="primary"
                        onClick={importData}
                        disabled={loading}
                    >
                        {loading ? "Importing..." : "Import Data"}
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    );
};

export default ImportAmanoReportModal;